exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._Pq2vw1WGuGujFRX5qZvo{position:absolute;outline-style:dashed;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._Pq2vw1WGuGujFRX5qZvo{background:\"[theme:neutralLight, default:#eaeaea]\"}._2I_2h8zNfKxchEG02m2fdk{font-size:32px;height:32px}html[dir] ._2I_2h8zNfKxchEG02m2fdk{margin-top:2px}.q7-V9rKWMf-Ir2bHpXGeT{font-size:25px;height:25px}html[dir] .q7-V9rKWMf-Ir2bHpXGeT{margin-top:1px}._3WJyeSRAbRBMWPjohsVQXL{font-size:28px;font-weight:100}._1Q_fnkbE-x3G_Xt3C8kzqq{font-size:21px;font-weight:100}", ""]);

// exports
exports.locals = {
	"dropHintArea": "_Pq2vw1WGuGujFRX5qZvo",
	"dropHintIconInBigSize": "_2I_2h8zNfKxchEG02m2fdk",
	"dropHintIconInSmallSize": "q7-V9rKWMf-Ir2bHpXGeT",
	"dropHintLabelInBigSize": "_3WJyeSRAbRBMWPjohsVQXL",
	"dropHintLabelInSmallSize": "_1Q_fnkbE-x3G_Xt3C8kzqq"
};